module.exports = __webpack_public_path__ + "static/media/maintence_1578667311475.23e214fa.jpg";